/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { observer } from 'mobx-react'
import { FavoriteIco } from '@shared/Icon/MatchupIcon'
import styled from '@themes/theme'
import { ButtonStyles } from '@styles/button.style'
import { favoritePulseAni, favoriteTxtAni } from '@styles/match.style'
import FavoriteImg from '@assets/images/btn/favorite-manage.png'
import FavoriteActiveImg from '@assets/images/btn/favorite-manage-active.png'

export interface FavoriteButtonProps {
  id?: string
  className?: string
  onClick?: (e: React.MouseEvent<HTMLElement>) => void
  hideBg?: boolean
  hideStyle?: boolean
}

const FavoriteBtn = <img src={FavoriteImg} className='favorite-btn-img' alt='favorite-btn'/>
const FavoriteActiveBtn = <img src={FavoriteActiveImg} className='favorite-btn-active-img' alt='favorite-btn-active'/>

const userPickFavoriteBtnCommonStyle = css`
  width: 27px;
  height: 27px;
  margin: 0;

  .btn-bg {
    display: none;
  }

  svg {
    width: 36px;
  }
`
const PickFavoriteBtn = styled.button`
  ${ButtonStyles};
  z-index: 0;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  overflow: visible;
  background: ${props => props.theme.color.TP};

  .btn-bg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 27px;
    height: 27px;
    border-radius: 50%;
    background: ${props => props.theme.color.mainBg};
    overflow: hidden;
  }

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 30px !important;
    height: auto;
    .fill{
      fill: transparent;
    }
  }
  .favorite-btn-img{
    width: 16px;
    height: auto;
    opacity: 1;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .favorite-btn-active-img{
    width: 16px;
    height: 16px;
    opacity: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .favorite-pulse {
    opacity: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 10px;
    height: 10px;
    border-radius: 50%;

    &.pulse-2 {
      width: 6px;
      height: 6px;
    }
  }

  &.active {
    .btn-bg {
      overflow: visible;
    }
    .favorite-btn-img{
      opacity: 0;
    }
    .favorite-btn-active-img{
      opacity: 1;
    }
    svg .fill{
      fill: transparent;
    }

    &.ani {
      .favorite-btn-active-img{
        animation: ${favoriteTxtAni} .4s 1 forwards cubic-bezier(.43, -0.78, 0, 1.66);
      }
      .favorite-pulse {
        opacity: 1;
        animation: ${favoritePulseAni} .65s 1 ease-out;

        &.pulse-2 {
          animation-delay: .1s;
        }
      }

      svg {
        animation: ${favoriteTxtAni} .4s 1 forwards cubic-bezier(.43, -0.78, 0, 1.66);
      }
    }
  }

  &.disabled {
    opacity: .3;
    svg {
      .fill{
        fill: #405060 !important;
      }
    }
    .favorite-btn-img {
      opacity: 0;
    }
    .favorite-btn-active-img {
      opacity: 0;
    }
    .btn-bg {
      background: ${props => props.theme.color.mainColor};
    }
  }

  // 프리미엄 분석가 페이지 찜버튼
  &#todayPickFavoriteBtn {
    ${userPickFavoriteBtnCommonStyle};
  }

  // 프리미엄 분석가 경기분석 찜버튼
  &#companyPickFavoriteBtn {
    margin: 0 14px;

    svg {
      width: 40px;
    }
  }

  // 나도 승부사 찜버튼
  &#userPickFavoriteBtn {
    ${userPickFavoriteBtnCommonStyle};
  }

  // 나도 승부사 경기 분석 찜버튼
  &#userPickDetailFavoriteBtn {
    ${userPickFavoriteBtnCommonStyle};
    position: absolute;
    top: 10px;
    right: 14px;
  }
`

export const FavoriteButton: React.FC<FavoriteButtonProps> = observer((props) => {
  const { id, className, onClick, hideBg = false, hideStyle = false } = props

  return (
    <PickFavoriteBtn
      id={id}
      className={className}
      onClick={onClick} /* 고정배 버블링 제어 코드가 작동하지 않는 이슈가 있어 수정 */
    >
      {!hideStyle && (
        <Fragment>
          {!hideBg && <span className="btn-bg"/>}
          <span className="favorite-pulse"/>
          <span className="favorite-pulse pulse-2"/>
          {FavoriteBtn}
          {FavoriteActiveBtn}
          <FavoriteIco/>
        </Fragment>
      )}
    </PickFavoriteBtn>
  )
})
